import { FunctionComponent, useEffect } from "react";

import { useLocation } from "react-router-dom";

// For more information, see https://reactrouter.com/web/guides/scroll-restoration/scroll-to-top
export const ScrollToTop: FunctionComponent = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};
